export const BULK_SELECT_CONFIRMATION_THRESHOLD = 250;

export const SUPPLIERS_MESSAGES = {
  CREATE_SUCCESS: "Entreprise créée avec succ\u00e8s",
  CREATE_ERROR: "Erreur lors de la création de l'entreprise",
  UPDATE_SUCCESS: "Entreprise mise \u00e0 jour avec succ\u00e8s",
  UPDATE_ERROR: "Erreur lors de la mise \u00e0 jour de l'entreprise",
  DELETE_SUCCESS: "Entreprise supprimée avec succ\u00e8s",
  DELETE_ERROR: "Erreur lors de la suppression de l'entreprise",
  DELETE_ERROR_LINKED_TO_ACCOUNTING:
    "Ce fournisseur est associé à des affectations comptables",
  BULK_DELETE_SUCCESS: (count: number) =>
    count === 1
      ? "L'entreprise a été supprimée avec succ\u00e8s"
      : `${count} entreprises ont été supprimées avec succ\u00e8s`,
  BULK_DELETE_ERROR: "Une erreur est survenue lors de la suppression",
} as const;
